'use strict';

import React, { Component, Fragment } from 'react';
import ValidationOverlay from './validationOverlay.jsx';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, Button, Box } from '@material-ui/core';
import PopUp from '../../../commonModules/interface/PopUp.jsx';
import NewSimul from './newSubscription/NewSimul.jsx';
import NewKWH from './newSubscription/NewKWH.jsx';
import InputText,{ InputSelect } from '../../../commonModules/interface/form-input-inline';
import { SingleCheckbox } from '../../../commonModules/MUI/RadioAndCheckbox.jsx';
import {  toast } from 'react-toastify';

const periodTab = [
    { title: "Jour", name: "day", nameStart:"evening", class: "table-kwh1"},
    { title: "Soir", name: "evening", nameStart:"night", class: "table-kwh2"},
    { title: "Nuit", name: "night", nameStart:"day", class: "table-kwh3"},
]
const dayTab = [
    { title: "Lundi", name: "monday"},
    { title: "Mardi", name: "tuesday"},
    { title: "Mercredi", name: "wednesday"},
    { title: "Jeudi", name: "thursday"},
    { title: "Vendredi", name: "friday"},
    { title: "Samedi", name: "saturday"},
    { title: "Dimanche", name: "sunday"}
]
class NewSubscription extends Component{

    state ={
        //Initiate Default User
        msg: "",
        popupState: this.props.popupState,
        popupStateValidation: false,
        Name: "",
        UnlockType: "myjoulebox",
        Type: "PayGo",
        Priceday:"",
        StockManagement: "nolink",
        Pricemonth: "",
        UnlockPrice: "",
        Currency: "",
        MinimumDeposit: "",
        errmsg: "",
        errUnlock: "",
        url: "",
        numberPeriod: 1,
        period:[
            {
                days:"",
                price:"",
            },
        ],
        errors:[
            {
                days:"",
                price:"",
            },
        ],
        simulation:{
            priceP:"",// price per period
            priceTotal:"",// total system price
            dureeA:"",// duree abo en mois
            base:"",// nb jour periode de base
            realP:"",// prix réel a partir des valeurs arrondies

        },
        Kwh: {
            day: {
                start: "8:00",
                end: "18:00",
            },
            evening: {
                start: "18:00",
                end: "23:00",
            },
            night: {
                start: "23:00",
                end: "8:00",
            },
            monday: {
                day:"",
                evening:"",
                night:"",
            },
            tuesday: {
                day:"",
                evening:"",
                night:"",
            },
            wednesday: {
                day:"",
                evening:"",
                night:"",
            },
            thursday: {
                day:"",
                evening:"",
                night:"",
            },
            friday: {
                day:"",
                evening:"",
                night:"",
            },
            saturday: {
                day:"",
                evening:"",
                night:"",
            },
            sunday: {
                day:"",
                evening:"",
                night:"",
            },
            abo: "",
            aboPrice: "",
            aboPriceTotal: "",
            maxCredit: "",
            paymentType: "",
            installCost: "", 
        },
        dialogSimul:false,
        install: true,
        product: false,
        electricQ: [
            {
                id: "default_electrical_question",
                name: "default_electrical_question"
            }
        ],
        electricR: "default_electrical_question",
        agentR: "DefaultInstallerSchemaID",
        agentQ: [
        {
            id: "DefaultInstallerSchemaID",
            name: "DefaultInstallerSchemaID"
        }
        ],
        //Photo of the installation
        photo1Q: [
        {
            id: "default_photo_question",
            name: "default_photo_question"
        }
        ],
        photo1R: "default_photo_question",
        solarQ: [
        {
            id: "default_solar_question",
            name: "default_solar_question"
        }
        ],
        solarR: "default_solar_question",
        otherQ: [
        {
            id: "default_otherI_question",
            name: "default_otherI_question"
        }
        ],
        otherR: "default_otherI_question"
    }
    onValidation= async (e) => {
        e.preventDefault();
        //Test if ok
        let numberPeriod = this.state.numberPeriod
        let period = this.state.period
        let periodTab = []
        let allPeriod = this.state.period
        let errors = this.state.errors
        let errmsg = ""
        let errUnlock = ""
        let haserror = false

        if (this.state.Name === ''){
            errmsg = "Veuillez remplir ce champ"
            errmsg =  "Name must be filled"
            haserror = true
        }
        if (this.state.UnlockPrice === '' && this.state.Type !== 'wifi'){
            errUnlock = "Veuillez remplir ce champ"
            errmsg =  "Unlock price must be filled"
            haserror = true
        }

        if(this.state.Type !== 'Cash' && this.state.Type !== 'jouly-prepaid-kwh-limit-day'){

            for (let i = (allPeriod.length) -1; i > -1 ; i--){
                let p = allPeriod[i]
                console.log("period index -> p", i , "->", p);
                console.log("period number period, pIndex", numberPeriod);
                
                if(p.days === "" && p.price === "" && i !== 0){
                    period.splice(i,1)
                    errors.splice(i,1)
                    
                    numberPeriod -= 1
    
                } else if(p.days === "" && p.price === ""){// error
                    errors[i].price = "Veuillez remplir ce champ"
                    errors[i].days = "Veuillez remplir ce champ"
                    errmsg =  "Day & Price can be null"
                    haserror = true
    
                } else if(p.days === "") {// error
                    errors[i].days = "Veuillez remplir ce champ"
                    errmsg =  "Day can be null"
                    haserror = true
    
                } else if(p.price === "") {// error
                    errors[i].price = "Veuillez remplir ce champ"
                    errmsg =  "Price can be null"
                    haserror = true
    
                } else { // no errors
                    period[i] = {
                        days:parseInt(p.days),
                        price:parseInt(p.price)
                    } 
                    errors[i]={
                        days:"",
                        price:""
                    }
                }
                
            }
        }

        this.setState({errUnlock, errmsg,errors, numberPeriod})
        if(haserror){
			toast.error('ERREUR '+errmsg)
            return
        }
        // "Record Subscription nom:"+this.state.Name + ", type: "+this.state.Type+", Prix jour :"+this.state.Priceday+ ", Prix Mois :"+this.state.Pricemonth + ", type de session : "+this.state.UnlockPrice+ ", minimum activation : "+this.state.MinimumDeposit+", currency : "+this.state.Currency
        console.log("PERIOD, ERRORS",period, errors)
        var msg = (
            <div>
                <h5 className="text-center">Valider l'Abonnement</h5>
                <Table className="table table-hover">
                    <TableBody>
                        <TableRow>
                            <TableCell>Nom</TableCell>
                            <TableCell>{this.state.Name}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Type</TableCell>
                            <TableCell>{this.state.Type}</TableCell>
                        </TableRow>
                        {this.state.type &&
                            <TableRow>
                                <TableCell>Forfaits</TableCell> 
                                <TableCell>
                                    <Table className="table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Periodicité</TableCell>
                                                <TableCell>Prix</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {period.map((p,i) => (
                                                <TableRow key={i}>
                                                    <TableCell>{p.days} {p.days > 1 ? "Jours": "Jour"} : </TableCell>
                                                    <TableCell>{p.price}</TableCell>
                                                </TableRow>
                                            ))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableCell>
                            </TableRow>
                        }
                        <TableRow>
                            <TableCell>Prix Total</TableCell>
                            <TableCell>{this.state.UnlockPrice}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Minimum Depot</TableCell>
                            <TableCell>{this.state.MinimumDeposit}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Paiement Mininal</TableCell>
                            <TableCell>{this.state.MinimumPayment}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Devise</TableCell>
                            <TableCell>{this.state.Currency}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Besoin d'une Installation</TableCell>
                            <TableCell>{(this.state.install ? "Oui" : "Non")}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Renseigner ID Produit lors de la Souscription</TableCell>
                            <TableCell>{(this.state.product ? "Oui" : "Non")}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Stock Link</TableCell>
                            <TableCell>{this.state.StockManagement}</TableCell>
                        </TableRow>
                        
                    </TableBody>
                </Table>
            </div>
        );
        if(this.state.Type !== 'Cash'){

            periodTab = [{ // in back, period[0] = priceDay  need this
                'Day': parseInt(period[0].days),
                'Month': 0,
                'Year': 0,
                'Price': parseFloat(period[0].price)
            }]
            period.map((p, i)=>{
                if(i !== 0){
    
                    periodTab.push( {
                        'Day': parseInt(p.days),
                        'Month': 0,
                        'Year': 0,
                        'Price': parseFloat(p.price)
                    })
                }
            })
            
            console.log(periodTab);
        }
        
        var url = "/subscription/new2?name=" + this.state.Name + 
        "&type=" + this.state.Type + 
        "&period=" + JSON.stringify(periodTab) + 
        "&unlockPrice=" + this.state.UnlockPrice+ 
        "&currency=" + this.state.Currency+ 
        "&deposit=" + this.state.MinimumDeposit+ 
        "&daydeposit="+ this.state.DayDeposit+ 
        "&minipayment="+ this.state.MinimumPayment+ 
        "&maxpower="+ this.state.MaxPower+
        "&fixcost="+ this.state.FixCost+
        "&connexioncost="+ this.state.ConnexionCost+
        "&kwhperday="+ this.state.KwhPerDay+
        "&pricekwh="+ this.state.PriceKwh+
        "&install=" + this.state.install+ 
        "&product=" + this.state.product+
        "&link=" + this.state.StockManagement+
        "&unlock=" + this.state.UnlockType+
        "&q1="+this.state.solarR+
        "&q2="+this.state.electricR+
        "&q3="+this.state.photo1R+
        "&q4="+this.state.otherR;
        console.log("[DEBUG], Prevalidation OK")
        //Active Pop up Security
        this.setState({
            popupStateValidation: true,
            msg:msg,
            url:url,
            numberPeriod 
        });
    }
    // onClose= async (e) => {
    //   e.preventDefault();
    //   this.setState({popupState:false,popupStateValidation:false});
    //   this.props.onCloseOverlay();
    // }
    onCancelation= async () => {
        this.setState({
            popupStateValidation:false,
        })
    }
    onValidationSucceed= async () => {
        console.log("onValidationSucceed ==> ")
      this.setState({     
        msg: "",
        popupState: false,
        popupStateValidation: false,
        Name: "",
        Type: "PayGo",
        UnlockType: "myjoulebox",
        StockManagement: "nolink",
        Priceday:"",
        Pricemonth: "",
        UnlockPrice: "",
        Currency: "",
        MinimumDeposit: "",
        DayDeposit: "",
        MinimumPayment: "",
        MaxPower:"",
        errmsg: "",
        url: "", 
        numberPeriod: 1,
            period:[
                {
                    days:"",
                    price:"",
                },
            ],
            errors:[
                {
                    days:"",
                    price:"",
                },
            ],
            simulation:{
                priceP:"",// price per period
                priceTotal:"",// total system price
                dureeA:"",// duree abo en mois
                base:"",// nb jour periode de base
                realP:"",// prix réel a partir des valeurs arrondies

            },
            dialogSimul:false,
            install:true,
            product: false
    });
      this.props.onCloseOverlay();
    }

    onChange = (e) => {
        const {name, value} = e.target
        this.setState({[name]: value});
    }
    onChangeSelect = (name, value) => {
        this.setState({[name]: value});
    }
    onChangeName= async (e) => {
        e.preventDefault();
        var name = e.target.value;
        this.setState({Name: name});
    }
    onChangeType= async (e) => {
      e.preventDefault();
      var type = e.target.value;
      this.setState({Type: type});
    }
    onChangePriceday= async (e) => {
        e.preventDefault();
        var priceday = e.target.value;
        this.setState({Priceday: priceday});
    }
    onChangePricemonth= async (e) => {
        e.preventDefault();
        var pricemonth = e.target.value;
        this.setState({Pricemonth: pricemonth});
    }
    onChangeUnlockPrice= async (e) => {
        e.preventDefault();
        var unlockPrice = e.target.value;
        this.setState({UnlockPrice: parseFloat(unlockPrice)});
    }
    onChangeCurrency= async (e) => {
        e.preventDefault();
        var currency = e.target.value;
        this.setState({Currency: currency});
    }
    onChangePeriod= async (e) => {
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        let splitTab = e.target.name.split("-")
        let name = await splitTab[0]
        let index = await splitTab[1]
        let periods = this.state.period

        console.log("[INFO] name, index, value", name, index, value);
        console.log("[INFO] Period before update", this.state.period);

        if (value === "" || regex.test(value)){
            periods[index][name] = value
            console.log("[INFO] Periods array", periods);
            await this.setState({
                ...this.state,
                period:periods
            })
        }

    }
    componentDidMount= async () => {
        console.log('[DEBUG], paygoGet All, load schema ');
        let listSchema = [];
        try {
          const response = await fetch('/schema/list', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
              //'X-CSRF-TOKEN': document.getElementsByName("_csrf")[0].content
            },
            credentials: 'same-origin'
          });
          const resp = await response.json();
          console.log("[INFO], Response for list of all schema : , ");
          console.log(resp);
          if (resp.content.lenght == 0) {
            console.log("[ERROR], getting schema getAll response ", resp)
            return;
          }
          //Parse content
          resp
            .content
            .map((item) => {
              console.log(item);
              listSchema = listSchema.concat({id: item.id, name: item.name});
            });
          this.setState({
            electricQ: this
              .state
              .electricQ
              .concat(listSchema),
            photo1Q: this
              .state
              .photo1Q
              .concat(listSchema),
            agentQ:this
              .state
              .agentQ
              .concat(listSchema),
            solarQ: this
              .state
              .solarQ
              .concat(listSchema),
              otherQ: this
              .state
              .otherQ
              .concat(listSchema)
          });
        } catch (err) {
          console.log("[ERROR], getting schema for installater getAll data", err)
        }
      }

      addForm = () => {
        let tab = []
        console.log("IN ADDFORM");
        
        for(let i = 0; i < this.state.numberPeriod; i++){
            tab.push(
                <Grid container spacing={2} >
                    <Grid item xs={12} sm={6}>
                        <InputText 
                            type="number" 
                            name={"days-"+i} 
                            value={this.state.period[i].days} 
                            onChange={this.onChangePeriod} 
                            label={`Periodicité ${i=== 0 ? "Base" : i+1} (en Jour)`}
                            error={this.state.errors[i].days}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputText 
                            type="number" 
                            name={"price-"+i} 
                            label={`Prix Periode ${i=== 0 ? "Base" : i+1}`}
                            value={this.state.period[i].price} 
                            onChange={this.onChangePeriod}
                            error={this.state.errors[i].price}
                        />
                    </Grid>
                </Grid>
            )
        }
        return tab
    }
    addkWhForm = () => {
        let tab = []
        console.log("IN ADDFORM");
        
        for(let i = 0; i < this.state.numberPeriod; i++){
            tab.push(
                <Grid container spacing={2} >
                    <Grid item xs={12} sm={6}>
                        <InputText 
                            type="number" 
                            name={"days-"+i} 
                            value={this.state.period[i].days} 
                            onChange={this.onChangePeriod} 
                            label={`Tranche ${i=== 0 ? "Base" : i+1} (en kWh)`}
                            error={this.state.errors[i].days}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputText 
                            type="number" 
                            name={"price-"+i} 
                            label={`Prix Kwh ${i=== 0 ? "Base" : i+1}`}
                            value={this.state.period[i].price} 
                            onChange={this.onChangePeriod}
                            error={this.state.errors[i].price}
                        />
                    </Grid>
                </Grid>
            )
        }
        return tab
    }
    handleAddForm = async () => {
        console.log("IN HANDLE ADDFORM");
        this.setState({
            ...this.state,
            period:[
                ...this.state.period,
                {
                    days:"",
                    price:"",
                },
            ],
            errors:[
                ...this.state.errors,
                {
                    days:"",
                    price:"",
                },
            ],
            numberPeriod: this.state.numberPeriod+1,
        })
    }
    handleSimulation= async (e) => {
        const name = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only

        if (value === "" || regex.test(value)){
            await this.setState({
                ...this.state,
                simulation:{
                    ...this.state.simulation,
                    [name]:value,
                }
            })
        }
        if(name === "priceP"){ // if change price then calc nb Month
            this.simulationYear()
        }else {// else calc price per period
            this.simulationPriceP()
        }
    }
    simulationPriceP =  () => {// calc price per period with (base/total/duree )
        let months = this.state.simulation.dureeA
        let base = this.state.simulation.base
        let total = this.state.simulation.priceTotal
        

        if(base && total && months){
            let totalSystem = parseFloat(total)
            let totalDays = (parseFloat(months)*30)
            base = parseFloat(base)
            let pricePeriod = Math.round(totalSystem / totalDays * base)
            console.log("totalSystem, totalDays, base, pricePeriod", totalSystem, totalDays, base, pricePeriod);
            
            this.setState({
                ...this.state,
                simulation:{
                    ...this.state.simulation,
                    priceP: pricePeriod,
                    realP: Math.round((totalDays/ base * pricePeriod)*100)/100
                }
            })
        }
        
    }
    simulationYear = () => {// calc nb Months to pay total system with (total, base, pricePeriod)
        let pricePeriod = this.state.simulation.priceP
        let base = this.state.simulation.base
        let total = this.state.simulation.priceTotal
        
        if(base && total && pricePeriod){
            let totalSystem = parseFloat(total)
            base = parseFloat(base)
            let months = Math.round(totalSystem / pricePeriod * base / 30)
            console.log("totalSystem, base, months", totalSystem, base, months);
            
            this.setState({
                ...this.state,
                simulation:{
                    ...this.state.simulation,
                    dureeA: months,
                    realP: Math.round((months*30 /base * pricePeriod)*100)/100
                }
            })
        }
        
    }
    handleSaveSimul = () => {
        console.log("Save simulation");
        
        const simul = this.state.simulation
        let period = this.state.period
        let UnlockPrice = this.state.UnlockPrice
        period[0] = {
            days:simul.base,
            price:simul.priceP
        }
        UnlockPrice = simul.priceTotal
        this.setState({
           ...this.state,
           period,
           UnlockPrice,
           dialogSimul:'none'
        })
    }

    handleChangeKwh = (e) => {
        let name = e.target.name
        let value = e.target.value
        const floats = ["day", "evening", "night", "installCost", "maxCredit", "aboPrice","unlockPrice"]
        let infos = name.split("_")
        if(infos.length > 1){

            let field = infos[0]
            let subField = infos[1]
            if (floats.includes(subField)) {
                value = parseFloat(value)
            }

            this.setState({
                Kwh:{
                    ...this.state.Kwh,
                    [field]: {
                        ...this.state.Kwh[field],
                        [subField]: value
                    }
                }
            })
        } else {
            if (floats.includes(name)) {
                value = parseFloat(value)
            }
            this.setState({
                Kwh:{
                    ...this.state.Kwh,
                    [name]: value
                    
                }
            })
        }
    }
    submitKwh = async () => {
        console.log('====================================');
        console.log("SUBMIT KWH SUSCRIPTION", this.state.Kwh);
        console.log('====================================');
        let data = {
            hoursList : {},
            priceList : {}
        }
        let Kwh = Object.assign({}, this.state.Kwh)
        periodTab.forEach(period => data.hoursList[period.name] = Kwh[period.name])
        dayTab.forEach(day => data.priceList[day.name] = Kwh[day.name])
        
        data.name = this.state.Name
        data.typePayment = this.state.Type
        data.abo = Kwh.abo
        data.aboPrice = !data.abo ? 0 : Kwh.aboPrice
        data.unlockPrice = parseFloat(this.state.UnlockPrice)
        data.installCost = Kwh.installCost
        data.maxCredit = Kwh.maxCredit
        data.paymentType = Kwh.paymentType
        data.currency = this.state.Currency

        data.q1 = this.state.solarR;
        data.q2 =this.state.electricR;
        data.q3 =this.state.photo1R;
        data.q4 =this.state.otherR;
        
        console.log('====================================');
        console.log({data});
        console.log('====================================');

        let response = await fetch("/subscription/new/kwh",{
            method:'POST',
            headers: { 
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            body:JSON.stringify({data}),
            credentials: 'same-origin',
        })
        let res = await response.json()
        console.log("SUBMIT KWH ", {res});
        //{res: {error: "OK"}}
        //{res: {error: {errorCode: 404, content: "Name Already Set"}}
        //TO implement
        
    }   
    render() {
        console.log("[STATE]",this.state);
        
        return (
            <PopUp
                title="Nouvel Abonnement"
                close={this.props.onCloseOverlay}
                submitAction={ 
                    (this.state.Type === "Kwh"  || this.state.Type === "PayGo-Kwh")  ? 
                    this.submitKwh : 
                    this.onValidation
                }
            >
                {this.state.dialogSimul &&
                    <NewSimul
                        save={this.handleSaveSimul}
                        close={() => this.setState({dialogSimul:false}) }
                        handleSimulation={this.handleSimulation}
                        {...this.state}
                    />
                }
                

                {this.state.Type === "PayGo" &&
                    <Box>
                        <Button color="secondary" onClick={() => this.setState({dialogSimul:true})} className="pull-right">Simuler un abonnement</Button>
                    </Box>
                }
                <Grid container spacing={2} >
                    <Grid item xs={12} sm={6}>
                        <InputText 
                            type="text" 
                            name="Name" 
                            value={this.state.Name}
                            onChange={this.onChange}
                            error={this.state.errmsg}
                            label="Nom de l'abonnement"
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputSelect 
                            value={this.state.Type} 
                            onChange={(option, value) => this.onChangeSelect("Type", value)} 
                            name="Type"
                            label="Type d'abonnement"
                            options={[
                                {label: "PayGo", value:"PayGo"},
                                {label: "PayGo-Day", value:"PayGo-Day"},
                                {label: "Cash", value:"Cash"},
                                {label: "Kwh", value:"Kwh"},
                                {label: "PayGo-Kwh", value:"PayGo-Kwh"},
                                {label: "Jouly-Prepaid-kWh", value:"jouly-prepaid-kwh"},
                                {label: "jouly-prepaid-kwh-limit-day", value:"jouly-prepaid-kwh-limit-day"},
                                {label: "Jouly-day-kwh", value:"jouly-day-kwh"},
                                {label: "wifi", value:"wifi"},
                            ]}
                        />
                    </Grid>
                    {this.state.Type === 'PayGo' &&
                    <Fragment>
                        <Grid item xs={12}>
                            {this.addForm()}
                            <Box p={2}>
                                <Button type="button" color="secondary" onClick={this.handleAddForm}>Ajouter une Periodicité</Button>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Acompte minimal (1ère periodicité incluse)" value={this.state.MinimumDeposit} onChange={this.onChange} name="MinimumDeposit"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Nombre de jour de débloquage pour l'acompte" value={this.state.DayDeposit} onChange={this.onChange} name="DayDeposit"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Paiement minimum" value={this.state.MinimumPayment} onChange={this.onChange} name="MinimumPayment"/>
                        </Grid>
                    </Fragment>
                    }
                    {
                    this.state.Type === 'wifi' &&
                    <Fragment>
                        <Grid item xs={12}>
                            {this.addForm()}
                            <Box p={2}>
                                <Button type="button" color="secondary" onClick={this.handleAddForm}>Ajouter une Periodicité</Button>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Max Data (0 = unlimited)" value={this.state.MinimumDeposit} onChange={this.onChange} name="MinimumDeposit"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Max upload" value={this.state.DayDeposit} onChange={this.onChange} name="DayDeposit"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Max Download" value={this.state.MinimumPayment} onChange={this.onChange} name="MinimumPayment"/>
                        </Grid>
                    </Fragment>
                    }
                    {this.state.Type === 'PayGo-Day' &&
                    <Fragment>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Prix par jour" value={this.state.FixCost} onChange={this.onChange} name="FixCost"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Acompte minimal (1ère periodicité incluse)" value={this.state.MinimumDeposit} onChange={this.onChange} name="MinimumDeposit"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Nombre de jour de débloquage pour l'acompte" value={this.state.DayDeposit} onChange={this.onChange} name="DayDeposit"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Paiement minimum" value={this.state.MinimumPayment} onChange={this.onChange} name="MinimumPayment"/>
                        </Grid>
                    </Fragment>
                    }
                    {(this.state.Type !== "Kwh" && this.state.Type !==  "jouly-prepaid-kwh" && this.state.Type !==  "jouly-day-kwh" && this.state.Type !== 'jouly-prepaid-kwh-limit-day' && this.state.Type !=='wifi') && 
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Prix total pour débloquer le système" value={this.state.UnlockPrice} onChange={this.onChange} name="UnlockPrice" error={this.state.errUnlock} />
                        </Grid>
                    }
                    {this.state.Type === 'jouly-prepaid-kwh-limit-day' &&
                    <Fragment>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Nombre de Wh par jour" value={this.state.KwhPerDay} onChange={this.onChange} name="KwhPerDay"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Prix du kWh" value={this.state.PriceKwh} onChange={this.onChange} name="PriceKwh"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Cout raccordement" value={this.state.ConnexionCost} onChange={this.onChange} name="ConnexionCost"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Paiement minimum" value={this.state.MinimumPayment} onChange={this.onChange} name="MinimumPayment"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Puissance maximale" value={this.state.MaxPower} onChange={this.onChange} name="MaxPower"/>
                        </Grid>
                    </Fragment>
                    }
                    {this.state.Type === 'jouly-day-kwh' &&
                    <Fragment>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Nombre de Wh par jour" value={this.state.FixCost} onChange={this.onChange} name="UnlockPrice" error={this.state.errUnlock} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Prix par jour" value={this.state.DayDeposit} onChange={this.onChange} name="DayDeposit"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Cout raccordement" value={this.state.ConnexionCost} onChange={this.onChange} name="MinimumDeposit"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Nombre de jour minimum" value={this.state.MinimumPayment} onChange={this.onChange} name="MinimumPayment"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Puissance maximale" value={this.state.MaxPower} onChange={this.onChange} name="MaxPower"/>
                        </Grid>
                    </Fragment>
                    }
                    {this.state.Type === 'jouly-prepaid-kwh' &&
                    <Fragment>
                        <Grid item xs={12}>
                            {this.addkWhForm()}
                            <Box p={2}>
                                <Button type="button" color="secondary" onClick={this.handleAddForm}>Ajouter une Periodicité</Button>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Partie Fixe mensuelle" value={this.state.FixCost} onChange={this.onChange} name="UnlockPrice" error={this.state.errUnlock} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Cout raccordement" value={this.state.ConnexionCost} onChange={this.onChange} name="MinimumDeposit"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Nombre de kWh de débloquage avec le raccordement" value={this.state.DayDeposit} onChange={this.onChange} name="DayDeposit"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Paiement minimum" value={this.state.MinimumPayment} onChange={this.onChange} name="MinimumPayment"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText type="number" label="Puissance maximale" value={this.state.MaxPower} onChange={this.onChange} name="MaxPower"/>
                        </Grid>
                    </Fragment>
                    }
                    {(this.state.Type === "Kwh" || this.state.Type === "PayGo-Kwh") && 
                        <NewKWH 
                            {...this.state}
                            handleChangeKwh={this.handleChangeKwh}
                            periodTab={periodTab}
                            dayTab={dayTab}
                        />
                    }
                    <br/>
                    <br/>
                    <Grid item xs={12} sm={6}>
                        <InputText type="text" label="Devise" value={this.state.Currency} onChange={this.onChange} name="Currency"/>
                    </Grid>
                    {/* <br/>
                    <br/> */}
                    <Grid item xs={12} sm={6}>
                        <InputSelect 
                            value={this.state.UnlockType} 
                            onChange={(option, value) => this.onChangeSelect("UnlockType", value)} 
                            name="UnlockType"
                            label="Déblocage par"
                            options={[
                                {label:"MyJouleBox", value:"myjoulebox"},
                                {label:"Paygee", value:"paygee"},
                                {label:"PaygOps", value:"paygops"},
                                {label:"Angaza", value:"angaza"},
                                {label:"GLP", value:"glp"},
                                {label:"Calin", value:"calin"},
                            ]}
                        />
                    </Grid>  
                    <Grid item xs={12} sm={6}>
                        <InputSelect 
                            value={this.state.StockManagement} 
                            onChange={(option, value) => this.onChangeSelect("StockManagement", value)} 
                            name="StockManagement"
                            label="Stock Link"
                            options={[
                                {label:"No Link", value:"nolink"},
                                {label:"Optional Link", value:"optional"},
                                {label:"Mandatory Link", value:"mandatory"},
                            ]}
                        />
                    </Grid>    
                    
                    <Grid item xs={12} sm={6}>
                        {/* <div className="checkbox m-b-15">
                            <label>
                                <input type="checkbox" name="install" checked={this.state.install} onChange={()=>this.setState({install:!this.state.install})}/>
                                <i className="input-helper"></i>
                                Installation Requise ?
                            </label>
                        </div>  */}
                        <Box p={1}>
                            <SingleCheckbox
                                value={this.state.install} 
                                label={"Installation Requise ?"} 
                                onChange={(e)=>this.setState({install:e.target.checked})}
                                name="install"
                                checked={this.state.install}
                                color="primary"
                            />
                        </Box>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        {/* <div className="checkbox m-b-15">
                            <label>
                                <input type="checkbox" checked={this.state.product} onChange={()=>this.setState({product:!this.state.product})} name="product" />
                                <i className="input-helper"></i>
                                Renseigner ID Produit lors de la Souscription ?
                            </label>
                        </div>                        */}
                        <Box p={1}>
                            <SingleCheckbox
                                value={this.state.product} 
                                label={"Renseigner ID Produit lors de la Souscription ?"} 
                                onChange={(e)=>this.setState({product:e.target.checked})}
                                name="product"
                                checked={this.state.product}
                                color="primary"
                            />
                        </Box>
                    </Grid>     
                    {this.state.install &&
                        <Grid container spacing={2} item xs={12}>
                            <Grid item xs={12} sm={6}>
                                <InputSelect
                                    label="Questionnaire 1"
                                    value={this.state.solarR}
                                    onChange={e => this.setState({solarR: e.value})}
                                    options={this.state.solarQ.map( item => (
                                            {value: item.id, label:item.name}
                                        ))
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputSelect
                                    label="Questionnaire 2"
                                    value={this.state.electricR}
                                    onChange={e => this.setState({electricR: e.value})}
                                    options={this.state.electricQ.map( item => (
                                            {value: item.id, label:item.name}
                                        ))
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputSelect
                                    label="Questionnaire 3"
                                    value={this.state.photo1R}
                                    onChange={e => this.setState({photo1R: e.value})}
                                    options={this.state.photo1Q.map( item => (
                                            {value: item.id, label:item.name}
                                        ))
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputSelect
                                    label="Questionnaire 4"
                                    value={this.state.otherR}
                                    onChange={e => this.setState({otherR: e.value})}
                                    options={this.state.otherQ.map( item => (
                                            {value: item.id, label:item.name}
                                        ))
                                    }
                                />
                            </Grid>
                        </Grid>
                    }                           
                </Grid>

                {this.state.popupStateValidation &&
                    <ValidationOverlay
                        msg={this.state.msg}
                        // popupStateButton={this.state.popupStateValidation}
                        url={this.state.url}
                        onValidation={this.onValidationSucceed}
                        onCancelation={this.onCancelation}
                    />
                }

            </PopUp>
            
        );
    }
};

export default NewSubscription
